import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// ** MUI Components
import { Box, Typography, Tooltip, IconButton, Button,  Avatar, AvatarGroup, } from "@mui/material";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

// ** Custom Component Imports
import CustomChip from "../../../components/mui/chip";
import dayjs from "dayjs";
import { ToastContainer, toast } from "react-toastify";
// ** Icon Imports
import Icon from "../../../components/icon";
import { GetTodo, SaveTodo } from "./ToDoLogic"
import { GetTimeLog, SaveTimeLog, GetEmployees } from "./PunchClockLogic"
import { getServiceRequests, getWorkRequirements } from "screens/DispatchBoard/logic/DispatchBoardLogic";
import _ from "lodash";
import { GetTour } from "./GetTour";
import { SaveTour } from "./SaveTour";
import { GetOnboardingStatus } from "components/logic/paymentgateway/GetOnboardingStatus";
import { useDashboardPermission } from "../permissions/DashboardPermissions";
import { convertESTToLocal } from "components/formatDate";
import { GetScorecardData } from "./GetScorecardData";

export const useIndexLogic = () => {
  //#region Hooks
  const navigate = useNavigate();
  //#endregion

  //#region Constants
  const contentHeightFixed = false;     
  //#endregion End of Constants
  //#region Permission Context
  const { DashboardPermissionProps } = useDashboardPermission();
  const {
    // Shift Management
    hasShiftGetPermission,
    hasShiftSavePermission,
    hasShiftDeletePermission,

    // Shift With Break
    hasShiftWithBreakGetPermission,

    // Breaks
    hasBreakGetPermission,
    hasBreakSavePermission,
    hasBreakDeletePermission,

    // To-Do
    hasToDoGetPermission,
    hasToDoSavePermission,
    hasToDoDeletePermission,

    // Tour
    hasTourGetPermission,
    hasTourSavePermission,

    // Scorecard
    hasScorecardGetPermission
  } = DashboardPermissionProps;
  //#endregion Permission Context

  //#region States

  const [loading, setLoading] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [tabMain, setTabMain] = useState('1')
  const [tabValue, setTabValue] = useState('1');
  const [tabTitle, setTabTitle] = useState("Main");
  const [openAssignTaskDlg, setOpenAssignTaskDlg] = useState(false);
  const [tabAssignTaskValue, setTabAssignTaskValue] = useState('1');
  const [activeButton, setActiveButton] = useState("All");
  const [openToDoDlg, setOpenToDoDlg] = useState(false);
  const [openAddEmpDlg, setOpenAddEmpDlg] = useState(false);
  const [openEditClockInOutDlg, setOpenEditClockInOutDlg] = useState(false);
  const [todos, setTodos] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [rows, setRows] = useState([]);
  const [rowsLoading, setRowsLoading] = useState(false);
  
  const [checkIn,    setCheckIn]    = useState(false);
  const [timeLogId,  setTimeLogId]  = useState(0);
  const [checkInDt,  setCheckInDt]  = useState(null); // dayjs object
  const [pastMs,     setPastMs]     = useState(0);    // sum of closed sessions
  const [elapsedMs,  setElapsedMs]  = useState(0);    // ms since open session
  
  const [joinedData, setJoinedData] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [rowsAssignedTasks, setRowsAssignedTasks] = useState([]);
  const [taskFilterType, setTaskFilterType] = useState("MY_OPENED");
  const [onboardingStatus, setOnboardingStatus] = useState({});
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [editingLog, setEditingLog] = useState(null);
  const [checkInLat, setCheckInLat] = useState(0)
  const [checkInLong, setCheckInLong] = useState(0)
  const [logsToday, setLogsToday] = useState([])
  const [onBreak, setOnBreak] = useState(false);
  const [breakStart, setBreakStart] = useState(null);
  const [breakElapsed, setBreakElapsed] = useState(0);
  const [scoreCardData, setScorecardData] = useState([]);

  const fetchScorecardData = async () => {
    if (!hasScorecardGetPermission) return;

      try{
        const response = await GetScorecardData();

        if(!response.isError){
          setScorecardData(response.result[0]);
        }
      }catch(error){
        console.error(error)
      }
  } 

  useEffect(() => {
    fetchScorecardData();
  }, [hasScorecardGetPermission])

  const getOnboardingStatus = async ()  => {
    try {
      const response = await GetOnboardingStatus(navigate);
      if (response && !response.isError) {
        setOnboardingStatus(response.result);        
      }
    }catch(e){
      console.error("Error fetching onboarding status:", e);
      return;
    }
  }

  const handleTabMainChange = (value) => {
    setTabMain(value);
  }

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const handlePaginationModel = (model) =>{
    if(model.pageSize === -1){
      setPaginationModel({
        page: 0,
        pageSize: -1,
      })
    }else{
      setPaginationModel(model);
    }  
  }

  // Task Management

  function buildAssignedTasksFromJoined(joinedData) {
    const assignedTasks = [];
  
    joinedData.forEach(sr => {
      // 1. Add top-level entities (Request, Assessment, Estimate, WorkOrder)
      let prefix = "";
      switch (sr.entityType) {
        case "Request":
          prefix = "REQ";
          break;
        case "Assessment":
          prefix = "AST";
          break;
        case "Estimate":
          prefix = "EST";
          break;
        case "WorkOrder":
          prefix = "WO";
          break;
        default:
          prefix = ""; // fallback
      }

      if (["Request", "Assessment", "Estimate", "WorkOrder"].includes(sr.entityType)) {
        assignedTasks.push({
          id: sr.requestID, // original requestID
          ID: `${prefix}-${sr.requestID}`, // your code format, can adjust
          Type: sr.entityType,
          title: sr.requestTitle,
          assignedTo: Array.isArray(sr.assignedToUsers) ? sr.assignedToUsers : [],
          status: sr.status,
          // Keep original IDs
          requestID: sr.requestID,
          description: sr.reqDescription || "",
          modifiedDate: sr.modifiedDate || null,
        });
      }
  
      // 2. Add jobs within workRequirements
      (sr.workRequirements || []).forEach(wr => {
        (wr.jobs || []).forEach(job => {
          // WorkOrder Job (occurrenceNo > 0)
          if (job.occurrenceNo > 0) {
            assignedTasks.push({
              id: job.jobID, // original jobID
              ID: `WOJ-${job.jobID}`,
              Type: "Work Order Job",
              title: sr.requestTitle,
              assignedTo: Array.isArray(job.assignees) ? job.assignees : [],
              status: job?.status || "",
              // Keep original IDs
              requestID: sr.requestID,
              workReqID: wr.workReqID,
              jobID: job.jobID,
              description: wr.description || "",
              modifiedDate: wr.modifiedDate || null,
            });
          }
          // Assessment Job (subServiceID === 0 && occurrenceNo === 0)
          if (wr.subServiceID === 0 && job.occurrenceNo === 0) {
            assignedTasks.push({
              id: job.jobID, // original jobID
              ID: `ASTJ-${job.jobID}`,
              Type: "Assessment Job",
              title: sr.requestTitle,
              assignedTo: Array.isArray(job.assignees) ? job.assignees : [],
              status: sr.status,
              // Keep original IDs
              requestID: sr.requestID,
              workReqID: wr.workReqID,
              jobID: job.jobID,
              description: sr.reqDescription || "",
              modifiedDate: wr.modifiedDate || null,
            });
          }
        });
      });
    });
  
    return assignedTasks;
  }

  const fetchAndJoin = async () => {
    
    let svcReqs = [];
    let wrs = [];
    setLoading(true)
    try {
      svcReqs = await getServiceRequests(navigate);
    } catch {
      toast.error("Unable to load jobs — please check your login.", {
        position: "top-right",
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      setLoading(false);
      return;
    }
    setLoading(true)
    try {
      wrs = await getWorkRequirements(navigate);
    } catch {
      toast.error("Unable to load job details.", {
        position: "top-right",
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      setLoading(false);
      return;
    }

    // Join requests with work requirements as before
    setLoading(true)
    const joined = svcReqs
      .map((sr) => {
        const matchingWRs = wrs.filter((w) => w.entityID === sr.requestID);

        // Only include WRs that have jobs (occurrenceNo > 0)
        const filteredWRs = matchingWRs
          .map((wr) => {
            const jobs = (wr.jobs || []).filter((j) => j.occurrenceNo > 0 || (wr.subServiceID === 0 && j.occurrenceNo === 0));
            return jobs.length ? { ...wr, jobs } : null;
          })
          .filter(Boolean);

          return { ...sr, workRequirements: filteredWRs };
      })
      .filter(Boolean);
      
    setJoinedData(joined);

    // Build and set assigned tasks array
    const assignedTasks = buildAssignedTasksFromJoined(joined);
    
    setRowsAssignedTasks(assignedTasks);

    setLoading(false);
  };

  useEffect(() => {
  getOnboardingStatus();
  fetchAndJoin();
  }, []);
  
  const closedStatuses = [
    "Completed", "Closed", "Canceled",
    "Rejected", "Canceled by Customer"
  ];
  
  function getCurrentEmployeeID() {
    const u = localStorage.getItem("user");
    return u ? JSON.parse(u).employeeID : null;
  }

  function filterTasks(tasks, filterType) {
    const userEmployeeID = getCurrentEmployeeID();
    return tasks.filter((task) => {
      const taskStatus = (task.status || "").trim();
  
      // Get all assigned employee IDs for this task (could be empty)
      const assignedIds = Array.isArray(task.assignedTo)
        ? task.assignedTo.map(u => u.employeeID)
        : [];
  
      switch (filterType) {
        case "MY_OPENED":
          // only tasks assigned to me that are NOT in any closed status
          return assignedIds.includes(userEmployeeID)
            && !closedStatuses.some(
                  closed => closed.toLowerCase() === taskStatus.toLowerCase()
                );
        case "ALL_TASKS":
          return true;
        case "ALL_OPENED":
          // Status NOT in closed
          return !closedStatuses.some(
            closed => closed.toLowerCase() === taskStatus.toLowerCase()
          );
        case "ALL_CLOSED":
          // Status IN closed
          return closedStatuses.some(
            closed => closed.toLowerCase() === taskStatus.toLowerCase()
          );
        case "MY_CLOSED":
          // Closed AND assigned to me
          return (
            closedStatuses.some(
              closed => closed.toLowerCase() === taskStatus.toLowerCase()
            ) &&
            assignedIds.includes(userEmployeeID)
          );
        default:
          return true;
      }
    });
  }
  
  // let filteredAssignedTasks = filterTasks(rowsAssignedTasks, taskFilterType); 
  let filteredAssignedTasks = filterTasks(rowsAssignedTasks, taskFilterType)
  .sort((a, b) => {
    // parse each modifiedDate (fallback to epoch for “no date”)
    const aDate = a.modifiedDate ? dayjs(a.modifiedDate) : dayjs(0);
    const bDate = b.modifiedDate ? dayjs(b.modifiedDate) : dayjs(0);
    // descending ⇒ b – a
    return bDate.diff(aDate);
  });

  // End Task Management

  // ─── parseServerDate: treat no‑offset strings as UTC ─────────
  // const parseServerDate = (s) => {
  //   if (!s) return null;
  //   // normalize space -> T
  //   let str = s.includes(" ") && !s.includes("T")
  //     ? s.replace(" ", "T")
  //     : s;
  //   // if no Z or +/-, assume UTC
  //   if (!/[Z+-]$/.test(str)) {
  //     str = str + "Z";
  //   }
  //   return dayjs(str);
  // };

  // pull employeeID from localStorage.user
  const getEmployeeID = () => {
    try {
      const u = localStorage.getItem("user");
      return u ? JSON.parse(u).employeeID : null;
    } catch {
      return null;
    }
  };

  const DB_FMT = 'YYYY-MM-DDTHH:mm:ss';
  const toDB   = d => dayjs(d).format(DB_FMT); 

  // ─── FETCH today’s logs, sum closed & detect open ───────────
  const fetchLogs = async () => {
    if (!hasShiftGetPermission) return;
    const employeeID = getEmployeeID();
    if (!employeeID) return;
  
    // 1) Fetch last 24h
  const from24h = toDB(dayjs().subtract(24, 'hour'));
  const toNow   = toDB(dayjs());
  const resp    = await GetTimeLog({ employeeID, timeLogId: 0, from: from24h, to: toNow });
  
    if (!resp || resp.isError || !Array.isArray(resp.result)) return;
  
    // Keep raw dayjs
    const logs = resp.result.map(l => {
      const checkin  = dayjs(l.checkin);
      const checkout = l.checkout ? dayjs(l.checkout) : null;
      return {
        ...l,
        checkinDt:  checkin,
        checkoutDt: checkout
      };
    });
  
    // 2) Open session?
    const open = logs.find(l => !l.checkoutDt);
    if (open) {
      setTimeLogId(open.timeLogID);
      setCheckInDt(open.checkinDt);                   // still a dayjs object
      setElapsedMs(dayjs().diff(open.checkinDt));
      setCheckInLat(open.checkInLatitude || 0);
      setCheckInLong(open.checkInLongitude || 0);
      setCheckIn(true);
      setPastMs(0);
      return;
    }
  
    // 3) Closed sessions today
    const startOfToday = dayjs().startOf('day');
    const closedToday = logs.filter(l => l.checkoutDt && l.checkinDt.isAfter(startOfToday));
  
    const sumClosed = closedToday.reduce((sum, l) => {
      const delta = Math.max(0, l.checkoutDt.diff(l.checkinDt)); // ms
      return sum + delta;
    }, 0);
  
    setPastMs(sumClosed);
    setTimeLogId(0);
    setCheckInDt(null);
    setElapsedMs(0);
    setCheckIn(false);
  };
  // ─── FETCH yesterday’s logs, sum closed ───────────
const fetchYesterdayLogs = async () => {
  if (!hasShiftGetPermission) return;
  const employeeID = getEmployeeID();
  if (!employeeID) return;

  // yesterday’s start & end
  const startOfYesterday = dayjs().subtract(1, "day").startOf("day");
  const endOfYesterday   = dayjs().subtract(1, "day").endOf("day");

  const resp = await GetTimeLog({
    employeeID,
    timeLogId: 0,
    from: toDB(startOfYesterday),
    to:   toDB(endOfYesterday)
  });

  if (!resp || resp.isError || !Array.isArray(resp.result)) return;

  // parse & sum
  const logs = resp.result.map(l => {
    const checkin  = dayjs(l.checkin);
    const checkout = l.checkout ? dayjs(l.checkout) : null;
    return { ...l, checkinDt: checkin, checkoutDt: checkout };
  });

  const closedYesterday = logs.filter(l => l.checkoutDt && l.checkinDt);
  const sumClosed = closedYesterday.reduce((sum, l) => {
    const delta = Math.max(0, l.checkoutDt.diff(l.checkinDt));
    return sum + delta;
  }, 0);

  return formatElapsed(sumClosed); // "HH:mm:ss"
};

  useEffect(() => {
    if(hasShiftGetPermission){
      fetchLogs();
    }
  }, [hasShiftGetPermission]);
 
  
  // ─── tick when checked‑in ────────────────────────────────
  const autoCheckout = async () => {
    if (!hasShiftSavePermission) return;
    const employeeID = getEmployeeID();
    if (!employeeID || !timeLogId || !checkInDt) return;
  
    // You can skip geolocation here (backend auto-close is the authority anyway)
    const payload = {
      timeLogID: timeLogId,
      employeeID,
      checkIn:  toDB(checkInDt),
      checkOut: toDB(dayjs()),
      checkInLatitude:  checkInLat,
      checkInLongitude: checkInLong,
      checkOutLatitude: checkInLat,
      checkOutLongitude: checkInLong
    };
  
    const resp = await SaveTimeLog(payload, 'update');
    if (!resp?.isError) {
      // locally reflect closed shift
      setCheckIn(false);
      setElapsedMs(0);
      await fetchLogs();
    }
  };

  
  const EXPIRY_MS = 24 * 60 * 60 * 1000; // 24h

  // inside your component
  const didAutoFetchRef = useRef(false);
  
 useEffect(() => {
  if (!checkIn || !checkInDt || onBreak) return;

  const startMs = dayjs(checkInDt).valueOf();

  const tick = () => {
    const elapsed = Date.now() - startMs + pastMs;
    setElapsedMs(elapsed);
  };

  tick();
  const id = setInterval(tick, 1000);
  return () => clearInterval(id);
}, [checkIn, checkInDt, onBreak, pastMs]);

// Change the break timer useEffect to calculate seconds instead of milliseconds
useEffect(() => {
  if (!onBreak || !breakStart) return;

  const tick = () => {
    const elapsedSeconds = Math.floor((Date.now() - breakStart.valueOf()) / 1000);
    setBreakElapsed(elapsedSeconds);
  };

  tick();
  const id = setInterval(tick, 1000);
  return () => clearInterval(id);
}, [onBreak, breakStart]);



  const formatElapsed = (ms) => {
    const sec = Math.floor(ms / 1000);
    const h   = String(Math.floor(sec / 3600)).padStart(2, "0");
    const m   = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const s   = String(sec % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };
  // Add this function to format seconds to HH:MM:SS
    const formatTime = (seconds) => {
      const hrs = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };
    const handleBreakToggle = () => {
      if (!checkIn) return; 

      if (!onBreak) {
        setPastMs(prev => prev + (Date.now() - checkInDt.valueOf()));
        setBreakStart(dayjs());
        setBreakElapsed(0);  

        // toastify message
        toast.success(" Break Started Successfully", {
          position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                  theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
                });
      } else {
        setCheckInDt(dayjs());
        setBreakStart(null);
        setBreakElapsed(0);
        toast.success("Break Ended Successfully", {
          position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
                });
      }

      setOnBreak(!onBreak);
    };


  // ─── Clock In / Out handler ───────────────────────────────
  // const handleCheckIn = async () => {
  //   if(!hasShiftSavePermission) return;

  //   const employeeID = getEmployeeID();
  //   if (!employeeID) return;

  //   const nowIso = dayjs().toISOString();
  //   let payload;

  //   if (!checkIn) {
  //     // start session
  //     payload = {
  //       timeLogID: 0,
  //       employeeID,
  //       checkIn: nowIso,
  //       checkOut: null,
  //     };
  //     const resp = await SaveTimeLog(payload, "save");
  //     if (!resp?.isError) {
  //       setTimeLogId(resp.result.timeLogID);
  //       setCheckInDt(dayjs(nowIso));
  //       setElapsedMs(0);
  //       setCheckIn(true);
  //     }
  //   } else {
  //     // end session
  //     payload = {
  //       timeLogID: timeLogId,
  //       employeeID,
  //       checkIn: checkInDt.toISOString(),
  //       checkOut: nowIso,
  //     };
  //     const resp = await SaveTimeLog(payload, "update");
  //     if (!resp?.isError) {
  //       await fetchLogs();
  //     }
  //   }
  // };
  const handleCheckIn = () => {
    if (!hasShiftSavePermission) return;
    const employeeID = getEmployeeID();
    if (!employeeID) return;
  
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
      return;
    }
  
    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        const now = dayjs();              // local
        const nowStr = toDB(now);         // "YYYY-MM-DDTHH:mm:ss"
  
        let payload;
  
        if (!checkIn) {
          // IN
          payload = {
            timeLogID: 0,
            employeeID,
            checkIn: nowStr,
            checkOut: null,
            checkInLatitude: latitude,
            checkInLongitude: longitude,
            checkOutLatitude: 0,
            checkOutLongitude: 0
          };
  
          const resp = await SaveTimeLog(payload, "save");
          if (!resp?.isError) {
            setTimeLogId(resp.result.timeLogID);
            setCheckInDt(now);          // keep as dayjs object
            setElapsedMs(0);
            setCheckIn(true);
            await fetchLogs();
            await load(); // Refresh the Manage Shifts grid
          }
        } else {
          // OUT
          payload = {
            timeLogID: timeLogId,
            employeeID,
            checkIn: toDB(checkInDt),    // we stored it as dayjs
            checkOut: nowStr,
            checkInLatitude: checkInLat,
            checkInLongitude: checkInLong,
            checkOutLatitude: latitude,
            checkOutLongitude: longitude
          };
  
          const resp = await SaveTimeLog(payload, "update");
          if (!resp?.isError) {
            await fetchLogs();
            await load(); // Refresh the Manage Shifts grid
          }
        }
      },
      (error) => {
        console.error("Geolocation error:", error);
        toast.error("Unable to retrieve location. Please allow location access.", { position: "top-right" });
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };
  
  // ─── render ───────────────────────────────────────────────
  const totalDisplay   = formatElapsed(pastMs);
  const currentDisplay = checkIn ? formatElapsed(elapsedMs) : "00:00:00";
  const dateDisplay    = dayjs().format("D MMM, YYYY");
  const [isTourCompleted, setIsTourCompleted] = useState(false);
  const [yesterdayDisplay, setYesterdayDisplay] = useState("00:00:00");

useEffect(() => {
  const loadYesterday = async () => {
    const display = await fetchYesterdayLogs();
    if (display) setYesterdayDisplay(display);
  };
  if (hasShiftGetPermission) {
    loadYesterday();
  }
}, [hasShiftGetPermission]);

  useEffect(() => {
    if(hasToDoGetPermission){
      fetchTodos();
    }
  }, [hasToDoGetPermission]);

  const fetchTodos = async() => {
    if(!hasToDoGetPermission) return;

    try {
      const fetchedTodos = await GetTodo(0);
      if (fetchedTodos && !_.isEqual(fetchedTodos.result, todos)) {
        // No change in todos, do nothing
        setTodos(fetchedTodos?.result);
      }       
    } catch (e) {
      console.error(e);      
    }
  }

  const handleTodoCheck = async (todo, newStatus) => {
    if(!hasToDoSavePermission) return;

    const payload = {
      toDoListId: todo?.toDoListId,
      name: todo?.name,
      description: todo?.description,
      status: newStatus ? "Active" : "Inactive"
    }

    try {
      const newTodo = await SaveTodo(payload, "update");
      
      if (newTodo) {
        fetchTodos();
      }
    } catch(e) {
      console.log(e);
      return;
    }
  }

  const filteredTodos = todos && todos.filter((t) => {
    if(!hasToDoGetPermission) return;

    switch (activeButton) {
      case "Upcoming":
        return (
          t.status === "Inactive" &&
          t.dueDate &&
          dayjs(t.dueDate).isAfter(dayjs(), "day")
        );
      case "Completed":
        return t.status === "Active";
      case "Overdue":
        return (
          t.status === "Inactive" &&
          t.dueDate &&
          dayjs(t.dueDate).isBefore(dayjs(), "day")
        );
      default:
        return true; // “All”
    }
  });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setTabTitle(
      newValue === "1"
        ? "Main"
        : newValue === "2"
        ? "Manage Shifts"
        : newValue === "3"
        ? "Task Management"
        : newValue === "4"
        ? "To-Do"
        : "N/A"
    );
  };

  const handleAssignTaskTabChange = (event, newValue) => {
    setTabAssignTaskValue(newValue);
  }

  const handleFilterClick = (button) => {
    setActiveButton(button);
  };

  const handleOpenAssignTaskDlg = ()  => setOpenAssignTaskDlg(true);
  const handleCloseAssignTaskDlg = ()  => setOpenAssignTaskDlg(false);

  const handleOpenToDoDlg = () => setOpenToDoDlg(true);
  const handleCloseToDoDlg = () => setOpenToDoDlg(false);

  const handleOpenAddEmpDlg = () => {
    setEditingLog(null);
    setOpenAddEmpDlg(true);
  }
  const handleCloseAddEmpDlg = () => setOpenAddEmpDlg(false);

  const handleOpenEditClockInOutDlg = (row) => {
    console.log(row)
  // row.employeeID comes from the loader (make sure you added that field in load())
    setEditingLog({
      timeLogID:  row.raw.timeLogID,
      employeeID: row.raw.employeeID,
      checkin:    row.raw.checkin,
      checkout:   row.raw.checkout
    });
    setOpenAddEmpDlg(true);
  };
  const handleCloseEditClockInOutDlg = () => setOpenEditClockInOutDlg(false);
  
  const handleSearchChange = (searchKeyWord) => {
    setSearchText(searchKeyWord);
  };

  const handleClearSearch = () => {
    handleSearchChange("");
  };

  const handleDashboardTourClose = () => {
    setIsTourOpen(false);
    handleSaveTour();
  }

  const handleSaveTour = async () => {
    if(!hasTourSavePermission) return;

    const payload = {
      tourID : 0,
      isTourCompleted: true,
    }
    const response = await SaveTour(payload, navigate);
    if (!response?.isError) {      
      setIsTourCompleted(true);
    } else {
      console.error("Failed to save tour completion:", response.message);
      toast.error("Failed to save tour completion. Please try again later.", {
        position: "top-right",
      });
    }
  }


   const filteredRows = (rows || [])
     .filter(row =>    
        Object.values(row).some(value =>
            value && value.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

  //#endregion end of handlers and methods

  //#region Columns Configuration

  const columnsAssignedTasks = [    
    {
      flex: 0.1,
      minWidth: 80,
      maxWidth: 100,
      field: "ID",
      headerName: "ID",
      renderCell: (params) => {
        const { row } = params;
    
        const typeToBase = {
          Request: "/requests",
          Assessment: "/assessments",
          "Assessment Job": "/assessments",
          Estimate: "/estimates",
          Estimates: "/estimates",
          WorkOrder: "/work-orders",
          "Work Order": "/work-orders",
          "Work Order Job": "/work-orders",
        };
    
        const base = typeToBase[row.Type] || "#";
        const to = base === "#" 
          ? "#" 
          : `${base}/detail/${row.requestID}`;
    
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Link
                component={RouterLink}
                to={to}
                underline="none"
                color="inherit"
                variant="body1"  // ← same as your <Typography>
                noWrap           // ← ensures ellipsis + single-line
              >
                {row.ID}
              </Link>
            </Box>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 120,
      field: "type",
      headerName: "Type",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography noWrap variant="body1">
                {row.Type}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 120,
      field: "title",
      headerName: "Title",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography noWrap variant="body1">
                {row.title}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      flex: 0.18,
      minWidth: 160,
      field: "assignedTo",
      headerName: "Assigned To",
      renderCell: (params) => {
        const { row } = params;
        const assignedTo = Array.isArray(row.assignedTo) ? row.assignedTo : [];
    
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            {assignedTo.length > 0 ? (
              <AvatarGroup
                className="pull-up"
                max={4}
                sx={{
                  "& .MuiAvatar-root": { width: 25, height: 25 },
                  "& .MuiAvatarGroup-avatar": { width: 25, height: 25 },
                }}
              >
                {assignedTo.map((user, idx) => {
                  const name = user.employeeName || user.userName || "";
                  // Use initials if no image
                  const initials = name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")
                    .slice(0, 2)
                    .toUpperCase();
                  // Optionally, get avatarUrl from user if available
                  const avatarUrl = user.avatarUrl || `/images/avatars/${(user.employeeID % 10) + 1}.png`;
                  return (
                    <Tooltip key={user.employeeID || idx} title={name}>
                      <Avatar
                        src={avatarUrl}
                        alt={name}
                        sx={{ width: 25, height: 25 }}
                      >
                        {initials}
                      </Avatar>
                    </Tooltip>
                  );
                })}
              </AvatarGroup>
            ) : (
              <Typography noWrap variant="body1" sx={{ color: "#aaa" }}>
                Unassigned
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 120,
      field: "status",
      headerName: "Status",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <CustomChip
            rounded
            size="small"
            skin="light"
            color={
              row.status === "Completed"
                ? "success"
                : row.status === "In-Progress"
                ? "info"
                : row.status === "Scheduled"
                ? "warning"
                : row.status === null
                ? undefined
                : row.status === ""
                ? undefined
                : row.status
                ? "secondary"
                : undefined // No color if status is falsy
            }
            label={row.status || ""}
            style={!row.status ? { backgroundColor: 'transparent' } : {}}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "description",
      headerName: "Description",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography noWrap variant="body1">
                {row.description}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
  ];

  const columnsEmployee = [
    {
      flex: 0.1,
      minWidth: 60,
      maxWidth: 80,
      field: "SN",
      headerName: "SN",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography noWrap variant="body1">
                {row.SN}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: "employee",
      headerName: "Employee",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography noWrap variant="body1">
                {row.employee}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 200,
      field: "clockIn",
      headerName: "Punch In",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography noWrap variant="body1">
                {row.clockIn}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 200,
      field: "clockOut",
      headerName: "Punch Out",
      renderCell: (params) => {
        const { row } = params;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography noWrap variant="body1">
                {row.clockOut}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "actions",
      minWidth: 20,
      headerName: "Action",
      renderCell: (params) => {
        const { row } = params;
        return (
          <IconButton
        onClick={() => handleOpenEditClockInOutDlg(row)} 
          >
        <Icon icon="tabler:pencil" />
      </IconButton>
        );
      },
    }
  ];

const load = async () => {
  if(!hasShiftGetPermission) return;

  setRowsLoading(true);
  try {
    // Fetch all employees
    const empResp = await GetEmployees(0);
    if (empResp?.isError || !Array.isArray(empResp.result)) {
      setRowsLoading(false);
      return;
    }
    const emps = empResp.result;

    // Create a map for quick employee lookup by employeeID
    const empMap = {};
    emps.forEach(emp => {
      empMap[emp.employeeID] = emp;
    });

    // last 7 days, but include through tomorrow to avoid TZ cutoff
    const from = dayjs().subtract(7, "day").startOf("day").toISOString();
    const to = dayjs().add(1, "day").endOf("day").toISOString();

    // Fetch all time logs at once using employeeID: 0
    const logResp = await GetTimeLog({
      employeeID: 0,
      timeLogId: 0,
      from,
      to,
    });

    if (logResp?.isError || !Array.isArray(logResp.result)) {
      setRowsLoading(false);
      return;
    }

    const FMT = 'MM/DD/YYYY hh:mm:ss A';

    // Map logs to rows, matching with employee data
    const newRows = logResp.result
      .map((log) => {
        const emp = empMap[log.employeeID];
        if (!emp) return null; // Skip if employee not found

        const checkinDt  = log.checkin  ? dayjs(log.checkin)  : null;
        const checkoutDt = log.checkout ? dayjs(log.checkout) : null;
      
        return {
          id: `${emp.employeeID}-${log.timeLogID}`,
          SN: '', // Will be set after sorting
          employee: `${emp.firstName} ${emp.lastName}`,
          clockIn : checkinDt  ? checkinDt.format(FMT)  : '',
          clockOut: checkoutDt ? checkoutDt.format(FMT) : '',
          raw: { 
            ...log, 
            checkinDt, 
            checkoutDt,
            // Store timestamp for sorting
            timestamp: checkinDt ? checkinDt.valueOf() : 0
          }
        };
      })
      .filter(Boolean); // Remove null entries

    // Sort by check-in timestamp in descending order (newest first)
    newRows.sort((a, b) => {
      return b.raw.timestamp - a.raw.timestamp;
    });

    // Set SN after sorting
    newRows.forEach((row, index) => {
      row.SN = String(index + 1).padStart(3, '0');
    });

    setRows(newRows);
    setRowsLoading(false);

  } catch(e) {
    console.error(e);
    setRowsLoading(false);
  }
};

  useEffect(()=>{
    const checkTour = async () => {
      if(loading) return; // Avoid checking if still loading
      try {
        if(isTourCompleted) return; // If tour is already completed, skip fetching tour data
        const tourData = await GetTour(navigate);
        if ((tourData && !tourData.isTourCompleted) || tourData === null) {          
          setIsTourOpen(true);
          setIsTourCompleted(true);
        }
      } catch (error) {
        console.error("Error fetching tour data:", error);
      }
    };
   
    if (!loading) {
      const delay = setTimeout(() => {
        checkTour();
      }, 300); // Delay ensures DOM is ready
      return () => clearTimeout(delay);
    }
    
  },[loading]);


  //#endregion end of Columns Configuration

  //#region IndexProps
  const IndexProps = {
    contentHeightFixed,
    collapse, 
    setCollapse,
    loading,
    tabValue,
    tabTitle,
    handleTabChange,
    tabMain,
    handleTabMainChange,
    checkIn,
    handleCheckIn,
    columnsAssignedTasks,
    // dummyRowsAssignedTasks,
    openAssignTaskDlg,
    handleOpenAssignTaskDlg,
    handleCloseAssignTaskDlg,
    tabAssignTaskValue,
    handleAssignTaskTabChange,
    activeButton,
    handleFilterClick,
    openToDoDlg,
    handleOpenToDoDlg,
    handleCloseToDoDlg,
    openAddEmpDlg,
    handleOpenAddEmpDlg,
    handleCloseAddEmpDlg,
    columnsEmployee,
    openEditClockInOutDlg,
    handleCloseEditClockInOutDlg,
    handleSearchChange,
    handleClearSearch,
    filteredRows,
    selectedEmployee,
    todos, 
    paginationModel,
    handlePaginationModel,
    searchText,
    setTodos,
    fetchTodos,
    handleTodoCheck,
    filteredTodos,
    setActiveButton,
    totalDisplay,
    currentDisplay,
    dateDisplay,
    rows,
    rowsLoading,
    rowsAssignedTasks,
    fetchAndJoin,
    fetchLogs,
    taskFilterType, 
    setTaskFilterType,
    filteredAssignedTasks,
    handleDashboardTourClose,
    isTourOpen,
    setIsTourOpen,
    yesterdayDisplay,
    onboardingStatus,
    load,
    onBreak,
    handleBreakToggle,
    breakElapsed,
    formatTime,
    navigate,
    editingLog,
    logsToday,
    scoreCardData
  };
  //#endregion end of IndexProps

  return {
    IndexProps,
  };
};
